import React from "react";
import "../../../styles/main.css";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";
import Subpage_101 from "../../../modules/caneva/Subpage_101_mockup";



const Page_101 = () => {
  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        boxSizing: "border-box",
        minWidth: 1200,   // largeur logique de page
      }}
    >
      <Breadcrumb
        items={[
          { label: "homepage", href: "/Homepage" },
          { label: "caneva / scope", href: "/page_101" },
        ]}
      />

      {/* <PageHeader
        title="Scope"
        className="title-caneva"
      />

      <hr className="page-separator" /> */}

      <main
        className="content"
        style={{
          padding: 0,
          margin: 0,
          background: "transparent",
          boxSizing: "border-box",
        }}
      >
        <Subpage_101 />
      </main>
    </div>
  );
};

export default Page_101;
